import { render, staticRenderFns } from "./ControlResponsables.vue?vue&type=template&id=23b368af"
import script from "./ControlResponsables.vue?vue&type=script&lang=js"
export * from "./ControlResponsables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports